import React from 'react'
import {Button} from 'react-bootstrap'
import Spinner from 'react-bootstrap/Spinner'
import {useTranslation} from 'react-i18next'
import {AuditPaneContext} from '../../context/AuditPane'
import {AuditContext} from '../../context/Audits'
import lowerCase from 'lodash/lowerCase'
import upperCase from 'lodash/upperCase'
import {Table, Column, InfiniteLoader} from 'react-virtualized'

function AuditItemTab({audit}) {
  const {t} = useTranslation()
  const paneState = React.useContext(AuditPaneContext)
  const {itemStart, setItemStart, getNextItems} = React.useContext(AuditContext)
  const [loading, setLoading] = React.useState(true)

  const _noRowsRenderer = () => {
    return (
      <div className="text_center audit-table__cell--none audit-table__cell--gray audit-table__cell--expand">
        No Records Found
      </div>
    )
  }

  const columnStatus = data => {
    return (
      <div
        className={
          'ap-pillbox ap-pillbox--19' +
          `${
            lowerCase(data.status) === 'scanned' || lowerCase(data.status) === 'manual'
              ? ' ap-pillbox--green'
              : ' ap-pillbox--gray'
          }`
        }
      >
        {`${upperCase(t(`audit.table.status.${data.status}`))}`}
      </div>
    )
  }

  const loadMore = () => {
    if (loading) {
      setLoading(false)
      getNextItems(audit.id, {
        start: itemStart + 1,
        limit: 30,
        entity_id: audit.audit_entities_attributes[0].entity_id,
      }).then(() => {
        setItemStart(itemStart + 1)
        setLoading(true)
      })
    }
  }

  const columnDisplayField = data => {
    if (data.id === 'loading') {
      return <Spinner className="item-spinner mt-15" animation="border" role="status" />
    }
    return data.display_field
  }

  const _rowClassName = index => {
    if (
      index !== -1 &&
      audit.expand_details.entities_attributes[0].entity_objects[index].id === 'loading'
    ) {
      return 'audit-table__row audit-table__row--no-border-top cursor_pointer loading_row'
    } else {
      return 'audit-table__row audit-table__row--35 audit-table__row--no-border-top'
    }
  }

  return (
    <div className="audit-item-tab">
      <>
        {audit.expand_details === undefined || audit.expand_details === null ? (
          <div className="text_center">
            <Spinner className="spinner" animation="border" role="status" />
          </div>
        ) : (
          <InfiniteLoader
            isRowLoaded={({index}) =>
              !!audit.expand_details.entities_attributes[0].entity_objects[index]
            }
            loadMoreRows={loadMore}
            rowCount={audit.expand_details.entities_attributes[0].entity_objects_count}
            threshold={8}
          >
            {({onRowsRendered}) => (
              <Table
                ref={'Table'}
                onRowsRendered={onRowsRendered}
                className="audit-table"
                rowClassName={h => _rowClassName(h.index)}
                headerHeight={33}
                width={328}
                height={630}
                rowHeight={38}
                rowCount={audit.expand_details.entities_attributes[0].entity_objects.length}
                rowGetter={({index}) =>
                  audit.expand_details.entities_attributes[0].entity_objects[index]
                }
                rowStyle={{overflow: 'visible'}}
                noRowsRenderer={_noRowsRenderer}
              >
                <Column
                  className="item-table__header overflow-content item-name__cell"
                  cellRenderer={c => columnDisplayField(c.rowData)}
                  label={upperCase(
                    audit.expand_details.entities_attributes[0].field_names.display_field
                  )}
                  dataKey="display_field"
                  width={328 * 0.5}
                />
                <Column
                  disableSort={true}
                  cellRenderer={c => columnStatus(c.rowData)}
                  className="audit-table__header audit-table__header--right audit-item-tab__cell--right"
                  label={`${upperCase(t('audit.table.columns.status'))} (${
                    audit.scanned_items_count
                  }/${audit.total_items_count})`}
                  dataKey="id"
                  width={328 * 0.5}
                />
              </Table>
            )}
          </InfiniteLoader>
        )}
      </>
      <div className="text_center mt_25">
        <Button onClick={paneState.openExpand} className="audit-detail-tab__button row">
          <i
            className="audit-icon--expand audit-icon--14 audit-icon--white mr_8"
            aria-hidden="true"
          ></i>
          {t('audit.detail-tab.labels.expand')}
        </Button>
      </div>
    </div>
  )
}

export default AuditItemTab
